import { createReducer, on } from '@ngrx/store';
import * as SupplierlistActions from './Supplierlist.action';

export interface SupplierState {
  suppliers: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: SupplierState = {
  suppliers: [],
  loading: false,
  error: null,
};

export const supplierlistReducer = createReducer(
  initialState,
  on(SupplierlistActions.loadSuppliers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(SupplierlistActions.loadSuppliersSuccess, (state, { suppliers }) => ({
    ...state,
    suppliers,
    loading: false,
  })),
  on(SupplierlistActions.loadSuppliersFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
